"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitOrder = void 0;
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("./computePrice");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const utils_1 = require("./utils");
function getProportionAdjustmentsByItems(totalItems, processingItems, adjustments) {
    const totalItemsAmount = (0, computePrice_1.computeTotalOrderItemsAmountWithReward)(totalItems);
    const processingItemsAmount = (0, computePrice_1.computeTotalOrderItemsAmountWithReward)(processingItems);
    const ratio = totalItemsAmount === 0 ? 0 : processingItemsAmount / totalItemsAmount;
    const percentageAdjustments = adjustments.filter(adj => adj.adjustmentUnit == domain_1.AdjustmentUnit.PERCENTAGE);
    const proportionFlatAdjustments = adjustments
        .filter(adj => adj.adjustmentUnit === domain_1.AdjustmentUnit.FLAT)
        .map(adj => ({
        ...adj,
        amount: (0, utils_1.limitDecimalCount)(adj.amount * ratio),
        maximumAmount: (0, utils_1.limitDecimalCount)((adj.maximumAmount || 0) * ratio),
    }));
    return [...percentageAdjustments, ...proportionFlatAdjustments];
}
/**
 * Split order by items
 * @param input
 * @param input.sourceOrder Order
 * @param input.splitItems PaymentLineItem[]
 * @param input.overrides
 * @param input.overrides.payments OrderPayment[]
 * @param input.overrides.adjustments Adjustment[]
 * @returns Order
 * @description This function splits the order by items and returns a new order object with the specified items and adjustments.
 * The adjustments are calculated based on the proportion of the split items to the total items in the order.
 * If overrides are provided, they will be used instead of calculating the adjustments.
 * @returns Order
 */
function splitOrder(input) {
    var _a;
    const { sourceOrder, splitItems, overrides } = input;
    const activeOrderItems = ((sourceOrder === null || sourceOrder === void 0 ? void 0 : sourceOrder.orderItems) || []).filter(computePrice_1.filterActiveOrderItem);
    const formatProcessingItems = splitItems
        .map(item => {
        const validItem = (0, utils_1.searchOrderItemById)(activeOrderItems, item.orderItemId);
        if (!validItem) {
            return null;
        }
        return {
            ...validItem,
            quantity: item.quantityPaid,
        };
    })
        .filter(item => item !== null);
    const finalizedAdjustments = (overrides === null || overrides === void 0 ? void 0 : overrides.adjustments) ||
        getProportionAdjustmentsByItems(activeOrderItems, formatProcessingItems, sourceOrder.adjustments || []);
    const newOrderSnapshot = {
        ...(0, lodash_clonedeep_1.default)(sourceOrder),
        orderItems: formatProcessingItems,
        adjustments: finalizedAdjustments,
        payments: (overrides === null || overrides === void 0 ? void 0 : overrides.payments) || [],
    };
    const updatedOrderItems = (newOrderSnapshot.orderItems || []).map(item => {
        return {
            ...item,
            discountAmount: (0, computePrice_1.computeOrderItemDiscount)(item),
            surchargeAmount: (0, computePrice_1.computeOrderItemSurcharge)(item),
        };
    });
    newOrderSnapshot.orderItems = updatedOrderItems;
    const orderDetails = (0, computePrice_1.computeOrderTotals)(newOrderSnapshot);
    const roundingAmount = (_a = newOrderSnapshot === null || newOrderSnapshot === void 0 ? void 0 : newOrderSnapshot.payments) === null || _a === void 0 ? void 0 : _a.filter(payment => (0, utils_1.isCompletedOrRefundedPayment)(payment.status)).reduce((prev, cur) => (0, utils_1.sumDecimals)([prev, cur.roundOffDifference]), 0);
    if (orderDetails.amountDue <= 0) {
        (0, utils_1.updateOrderAndItemsStatus)(newOrderSnapshot, domain_1.OrderStatus.COMPLETED, domain_1.OrderItemStatus.COMPLETED);
    }
    return {
        ...newOrderSnapshot,
        ...orderDetails,
        roundingAmount,
    };
}
exports.splitOrder = splitOrder;
//# sourceMappingURL=splitOrder.js.map